import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./PdfFluxoCaixa.scss";
import moment from "moment";
import { linhasDoResumo } from "../../../util/resumoPagamentos";

function PdfFluxoCaixa({ showPreviousPage, dados }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Fluxo-Caixa_${dados.dataInicial} a ${dados.dataFinal}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  return (
    <>
      <div
        ref={componentRef}
        className={`pdf-wrapper pdf-wrapper--lista ${dados.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-wrapper--pretoebranco" : ""}`}
      >
        <div className="pdf-fluxoCaixa-heading">
          <span className="semiDarkText">{dados.clinica}</span>
          <div>
            <span>
              {dados.titulo} de{" "}
              {dados.dataInicial === dados.dataFinal
                ? dados.dataInicial
                : `${dados.dataInicial} a ${dados.dataFinal}`}
            </span>
          </div>
        </div>

        <div className="pdf-fluxoCaixa-table-container">
          <table className="table">
            <tbody>
              <tr>
                <th>Data</th>
                <th>DFE</th>
                <th>Descrição</th>
                <th>Recebido/Pago por</th>
                <th>Pagamento</th>
                <th>Valor</th>
              </tr>
              {dados.rows.map((row, index) => (
                <tr key={index}>
                  <td>{moment(row.dataPagamento).format("DD/MM HH:mm")}</td>
                  <td>
                    {row.documentoEletronico
                      ? `${row.documentoEletronico.tipoDocumento} ${
                          row.documentoEletronico.nrDocumento
                        }${row.rce ? "/RCE " + row.rce.nrDocumento : ""} `
                      : "-"}
                  </td>
                  <td>
                    {row.descricao ? row.descricao : row.nome ? row.nome : ""}{" "}
                    {row.cliente?.nome
                      ? row.cliente.nome
                      : row.cliente
                        ? row.cliente
                        : ""}
                  </td>
                  <td>
                    {row.recebidoPor
                      ? row.recebidoPor
                      : row.pagaPor
                        ? row.pagaPor
                        : ""}
                  </td>
                  <td>{row.metodoPagamento}</td>
                  <td>
                    {row.tipo === "despesa" && "-"}
                    {row.valor}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pdf-fluxoCaixa-resumo-container">
          {/* O filtro antigo era `value !== 0 && value !== "0"`, que deixa
              passar um NaN — e era assim que saía impresso «UNDEFINED: NaN$00».
              `linhasDoResumo` exige um número e descarta os zeros. */}
          {linhasDoResumo(dados.resumo).map(([key, value]) => (
            <div className="pdf-fluxoCaixa-resumo-container__row" key={key}>
              <span className="pdf-fluxoCaixa-resumo-container__row__tipoPagamento">
                {key} {":  "}
              </span>
              <span className="pdf-fluxoCaixa-resumo-container__row__valorPagamento">
                {Number(value).toLocaleString("pt-BR")}$00
              </span>
            </div>
          ))}
          <div className="pdf-fluxoCaixa-resumo-container__total">
            <span className="pdf-fluxoCaixa-resumo-container__total__text">
              Saldo:{"  "}
            </span>
            <span className="pdf-fluxoCaixa-resumo-container__total__valor">
              {dados.saldo}
              {"$00"}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default PdfFluxoCaixa;
